import axios from 'axios'
import axiosConfig from './axiosConfig'

const baseURL = process.env.REACT_APP_BASE_URL

export const PaymentService = {
  initiatePayment: (paymentDetails) =>
    axios.post(`${baseURL}/payment/initiate`, paymentDetails, axiosConfig()),

  paymentSuccessful: (details, paymentId) =>
    axios.put(
      `${baseURL}/payment/success/${paymentId}`,
      details,
      axiosConfig()
    ),

  paymentFailed: (details, paymentId) =>
    axios.put(`${baseURL}/payment/fail/${paymentId}`, details, axiosConfig()),
}
